<template>
  <el-popover trigger="click" popper-class="nav-poper" placement="bottom-start">
    <ul class="drop-menu">
      <li>
        <el-button type="text"><span>账号管理</span></el-button>
      </li>
      <li>
        <el-button type="text" @click="logout"><span>退出登录</span></el-button>
      </li>
    </ul>

    <div slot="reference" class="c-profile">
      <div class="user-info">
        {{ account || ' ' }}
      </div>
      <Icon type="ios-arrow-down"></Icon>
    </div>
  </el-popover>
</template>
<script>
import { HOST_API } from '@/api/config'
export default {
  name: 'Profile',
  props: {
    account: {
      type: [Number, String],
      required: true
    },
    companyName: {
      type: String,
      default: ''
    },
    accountName: {
      type: String,
      default: '账号'
    }
  },
  data() {
    return {
      locationUrl: `${window.location.protocol}//${window.location.hostname}`
    }
  },
  methods: {
    logout() {
      this.$store.commit('setToken', '')
      window.location.href = `${HOST_API}/auth/logout?url=${this.locationUrl}`
    }
  }
}
</script>

<style lang="scss">
.nav-poper.el-popper {
  min-width: 90px;
}
</style>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';

.drop-menu {
  li {
    .el-button {
      color: #333;
      &:hover {
        color: $primary-color;
      }
    }
  }
}

.c-profile {
  margin-right: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .user-info {
    font-size: 14px;
    color: #000;
    margin-right: 5px;
    cursor: pointer;
  }
}
</style>
